import React from "react";
import { motion } from "framer-motion";

const ProgressBar = ({ step, totalSteps = 11 }) => {
  const percentage = Math.min(100, Math.max(0, Math.round((step / totalSteps) * 100)));

  return (
    <div className="fixed top-4 left-1/2 -translate-x-1/2 z-[999] w-[92%] max-w-2xl bg-white/75 backdrop-blur-2xl border border-white/80 shadow-2xl shadow-purple-900/10 rounded-full px-4 sm:px-6 py-2.5 flex items-center justify-between gap-3 sm:gap-5 transition-all duration-300">
      {/* Left Badge */}
      <div className="flex items-center gap-2 flex-shrink-0">
        <div className="w-7 h-7 rounded-full bg-gradient-to-tr from-purple-600 to-indigo-500 text-white flex items-center justify-center text-xs font-extrabold shadow-sm">
          {step}
        </div>
        <span className="hidden sm:inline-block font-semibold text-xs text-gray-700 tracking-tight">
          Step {step} of {totalSteps}
        </span>
      </div>

      {/* Center Progress Track */}
      <div className="flex-1">
        <div className="bg-gray-200/60 backdrop-blur-md h-2 rounded-full overflow-hidden relative p-[1px] shadow-inner border border-white/60">
          <motion.div
            initial={{ width: 0 }}
            animate={{ width: `${percentage}%` }}
            transition={{ type: "spring", stiffness: 50, damping: 14 }}
            className="bg-gradient-to-r from-purple-600 via-fuchsia-500 to-indigo-500 rounded-full h-full relative shadow-sm"
          >
            <div className="absolute inset-0 bg-gradient-to-b from-white/40 via-transparent to-black/10 rounded-full" />
          </motion.div>
        </div>
      </div>

      {/* Right Glass Counter Pill */}
      <div className="flex items-center flex-shrink-0">
        <div className="px-3 py-1 rounded-full bg-white/90 backdrop-blur-md border border-purple-200/80 shadow-xs flex items-center gap-1.5">
          <span className="font-extrabold text-xs text-purple-700 tracking-wide">
            {percentage}%
          </span>
          <span className="hidden sm:inline-block text-[10px] uppercase font-bold tracking-wider text-purple-400 border-l border-purple-100 pl-1.5">
            Done
          </span>
        </div>
      </div>
    </div>
  );
};

export default ProgressBar;
